import React from 'react'
import PropTypes from 'prop-types'
import Image from 'js/components/DatoRichText/DatoImage'
import cn from 'classnames'

export default function ImageBlock({
  image,
  caption,
  roundedCorners,
  alignment,
}) {
  // eslint-disable-next-line react/prop-types
  function Wrapper({ children, alignment }) {
    return alignment === 'full-width' ? (
      <div
        className={`
  w-screen, relative
  inset-x-1/2 -mx-50vw my-36 max-w-screen
  lg:static lg:-mx-64 lg:w-auto
  xxl:-mx-128
`}
      >
        {children}
      </div>
    ) : (
      <div>{children}</div>
    )
  }
  return (
    <Wrapper alignment={alignment}>
      <Image
        className={cn('my-24', {
          'rounded-16': roundedCorners,
        })}
        {...image.responsiveImage}
        lazy
      ></Image>
      {caption && <b className="text-center font-demibold">{caption}</b>}
    </Wrapper>
  )
}

ImageBlock.propTypes = {
  roundedCorners: PropTypes.bool,
  image: PropTypes.shape({
    responsiveImage: PropTypes.object,
  }),
  caption: PropTypes.string,
  alignment: PropTypes.oneOf(['center', 'full-width']),
}
